"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMithrilStateComponent = exports.IMithrilComponent = void 0;
const mobx_1 = require("mobx");
const mithril_1 = require("../mithril");
class IMithrilComponent {
    constructor(key) {
        this.lifeCycleParams = {};
        if (key != null) {
            this.lifeCycleParams.key = key;
        }
        if (this.onCreate) {
            this.lifeCycleParams.oncreate = this.onCreate.bind(this);
        }
        if (this.onUpdate) {
            this.lifeCycleParams.onupdate = this.onUpdate.bind(this);
        }
        if (this.onRemove) {
            this.lifeCycleParams.onremove = this.onRemove.bind(this);
        }
    }
    view() {
        const nodes = this.nodes;
        if (Array.isArray(nodes)) {
            return mithril_1.m.fragment(this.lifeCycleParams, nodes);
        }
        return mithril_1.m.fragment(this.lifeCycleParams, [nodes]);
    }
}
exports.IMithrilComponent = IMithrilComponent;
class IMithrilStateComponent extends IMithrilComponent {
    constructor() {
        super();
        this.reactions = [];
    }
    autorun(view) {
        this.reactions.push((0, mobx_1.autorun)(view));
    }
    reaction(expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    }
    onRemove() {
        this.reactions.forEach(r => r());
    }
}
exports.IMithrilStateComponent = IMithrilStateComponent;
//# sourceMappingURL=mithril.component.js.map